 import React from 'react';
import {Link, NavLink} from 'react-router-dom';
import Logo from '../assets/logo.png';
import TAC from "../TandC";
// import referals from "../.. /components/Referals/"
import { Container, Row,Col } from 'react-bootstrap';
import "./style.css"
import Cookies from "js-cookie"
import BTCRate from '../BTCRate';
 function AdminDashboard(props) {
  const handleLogOut = ()=>{
   Cookies.remove("admin--auth")
    props.history.push("/")
  }

  const year = new Date().getFullYear();
 
  return (
    <Container>
        <div>
          <div className="bts-exchange-page-wrapper">
          <div className="bts-exchange-page-caption-section">
              <div className="bts-landing-left-menu ">
                  <div className="bts-landing-page-caption-logo">
                  <Link to="/">
                      <img src={Logo} alt=""/>
                  </Link>
                  </div>
              </div>        
          </div>
          <div className="bts-landing-page-testimonials">
              <div className="d-flex justify-content-between nav-align">
              <div className="ts-landing-page-right-menu align-self-center">
              <BTCRate/>
              </div>
              <div className="ts-landing-page-right-menu align-self-center">
                  <span to="tel:+2348162898892" onClick={handleLogOut} className="blueText cursor b7 medText plain">
                      Log out
                  </span>
              </div>
              </div>
          </div>
          </div>
          <div className="px-0 mx-3 push">
              <Row className="justify-content-center">
                  <Col md={8}>
                    <div className="">
                        <p className="bts-welcome-text mt-3">You are welcome, Admin</p>
                    </div>
                  </Col>
              </Row>
              <Row className="justify-content-center">
              <Col md={8}>
              <div className="admin-route-container">
                      <NavLink to="/admin/dashboard" className="admin-route" activeClassName="admin-current">
                      Overview
                      </NavLink>

                      <NavLink to="/admin/transactions" className="admin-route" activeClassName="admin-current" >
                          Transactions
                      </NavLink>

                      <NavLink to="/admin/rate" activeClassName="admin-current"  className="admin-route">
                          Set rates
                      </NavLink>
                      <NavLink to="/admin/referrals"  className="admin-route" activeClassName="admin-current">
                           Referrals
                      </NavLink>
              </div>
            </Col>
              </Row>
              <Row className="justify-content-center">
                  <Col md={8}>
                      <div className="pt-4">
                          {props.children}
                      </div>
                  </Col>
              </Row>
          </div>
          <Container className="bts-exchange-footer px-5">
              <Row className="d-flex justify-content-between lightText">
                  <section>
                      <span className="mail">Copyright  Bitmasta Inc.</span><br/>
                      <span className="mail">All Rights Reserved {year}</span>
                  </section>
                  <section>
                      <span className="">
                          <TAC />
                      </span>
                  </section>
              </Row>
          </Container>
        </div>
    </Container>
  );
}

export default AdminDashboard;
